import { type ChangeEvent, type SyntheticEvent, useState } from 'react'
import { supabase } from '@/lib/supabase'
import type { UseSignupReturn } from '@/types'

export const useSignup = (): UseSignupReturn => {
  const [formData, setFormData] = useState({
    confirmPassword: '',
    email: '',
    fullName: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()
  const [isSuccess, setIsSuccess] = useState(false)

  const handleInputChange = (field: string) => {
    return (event: ChangeEvent<HTMLInputElement>) => {
      setFormData((previous) => {
        return {
          ...previous,
          [field]: event.target.value,
        }
      })
    }
  }

  const handleSignup = async (
    event: SyntheticEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault()
    setIsLoading(true)
    setError(undefined)
    setIsSuccess(false)

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match')
      setIsLoading(false)

      return
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long')
      setIsLoading(false)

      return
    }

    try {
      const { data, error: signUpError } = await supabase.auth.signUp({
        email: formData.email,
        options: {
          data: {
            full_name: formData.fullName,
          },
        },
        password: formData.password,
      })

      if (signUpError) {
        setError(signUpError.message)
      } else if (data.user) {
        setIsSuccess(true)
        // Note: Email confirmation might be required depending on Supabase settings
      }
    } catch (signUpError) {
      console.error('Signup error:', signUpError)
      setError('An unexpected error occurred')
    } finally {
      setIsLoading(false)
    }
  }

  return {
    error,
    formData,
    handleInputChange,
    handleSignup,
    isLoading,
    isSuccess,
  }
}
